// @flow
import React from 'react'
import Screen from '../../Components/Screen'

import Breadcrumbs from './Components/Breadcrumbs'
import Header from './Components/Header'
import Table from './Components/Table'

type Props = {
  tbtSignings: [],
  fetching: boolean,
  searchTerm: string,
  filters: {},
  pagination: {},
  componentDidMount: () => void,
  onChangeSearch: () => void,
  onSubmitSearch: () => void,
  onChangeFilter: () => void,
  onChangeTable: () => void,
  onClickRow: () => void,
}

export default class extends React.PureComponent<Props> {

  componentDidMount = () => this.props.componentDidMount()

  render() {

    const {
      tbtSignings,
      fetching,
      searchTerm,
      pagination,
      onChangeSearch,
      onSubmitSearch,
      onChangeTable,
      onClickRow,
    } = this.props

    return (

      <Screen>

        <Breadcrumbs />

        <Header
          searchTerm={searchTerm}
          onChangeSearch={onChangeSearch}
          onSubmitSearch={onSubmitSearch}
        />

        <Table
          tbtSignings={tbtSignings}
          fetching={fetching}
          pagination={pagination}
          onChangeTable={onChangeTable}
          onClickRow={onClickRow}
        />

      </Screen>

    )

  }

}
